exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2ERF {\n    vertical-align: top;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    width: 1.4em;\n    padding: 0;\n    margin: 0;\n}\n\n._1U9n, ._3Jt6 {\n    display: inline-block;\n    width: 0.7em;\n    vertical-align: inherit;\n}\n\n._1U9n > span {\n    left: -0.1em;\n    vertical-align: inherit;\n    height: 100%;\n}\n\n._3Jt6 > span {\n    right: 0.6em;\n    vertical-align: inherit;\n    height: 100%;\n    margin-left: 20px;\n}\n", ""]);

// exports
exports.locals = {
	"dualFlags": "_2ERF",
	"primaryFlag": "_1U9n",
	"secondaryFlag": "_3Jt6"
};